import { useConfigStore } from "@/stores/config"
import Bugsnag from "@bugsnag/js"
import type { QuestionsOptions } from "@/types/s3"

export async function getQuestions(options: QuestionsOptions) {
  const { urls } = useConfigStore()

  const url = `${urls.assets}/questions/${options.test}.json`

  const response = await fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  })
  const data = await response.json()

  if (!data || (Array.isArray(data) && data.length === 0)) {
    Bugsnag.notify(
      new Error("getQuestions returned an empty array"),
      (event) => {
        event.context = "getQuestions"
        event.severity = "error"
        event.unhandled = true
        event.addMetadata("request", {
          url,
          data,
        })
      }
    )
  }

  return { questions: data }
}
